import { NgModule } from "@angular/core";
import { DropdownSearchComponent } from "./dropdown-search/dropdown-search.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms"; 
import { OverlayModule } from '@angular/cdk/overlay';
import { NotificationsComponent } from "./notifications/notifications.component";
import { MatIconModule } from '@angular/material/icon';
import { CustomPipeModule } from "../services/pipe/custom-pipe.module";
import { CostBreakdownCardComponent } from 'src/app/management/inventory/cost-breakdown-card/cost-breakdown-card.component';
import { StockListCardComponent } from "src/app/management/inventory/stock-list-card/stock-list-card.component";
import { PaginatorModule } from "primeng/paginator"; //
import { ToolbarModule } from "primeng/toolbar"; //
import { TableModule } from 'primeng/table';
import { DirectivesModule } from '../services/directives/directives.module';
import { StockSelectorModalComponent } from 'src/app/management/inventory/stock-selector-modal/stock-selector-modal.component'
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ImageCropperModalComponent } from './image-cropper-modal/image-cropper-modal.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ButtonModule } from "primeng/button";
import { UserProfileComponent } from './user-profile/user-profile.component';
import { NavigationMenuComponent } from './navigation-menu/navigation-menu.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from "primeng/breadcrumb";
import { StatusTagComponent } from './status-tag/status-tag.component';
import { ChipModule } from "primeng/chip";

@NgModule({
  declarations: [
    DropdownSearchComponent,
    NotificationsComponent,
    CostBreakdownCardComponent,
    StockSelectorModalComponent,
    ImageCropperModalComponent,
    UserProfileComponent,
    NavigationMenuComponent,
    BreadcrumbComponent,
    StatusTagComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    MatIconModule,
    CustomPipeModule,
    PaginatorModule,
    ToolbarModule,
    TableModule,
    DirectivesModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ImageCropperModule,
    ButtonModule,
    InlineSVGModule.forRoot(),
    BreadcrumbModule,
    ChipModule
  ],
  exports: [
    DropdownSearchComponent,
    NotificationsComponent,
    CostBreakdownCardComponent,
    StockSelectorModalComponent,
    ImageCropperModalComponent,
    UserProfileComponent,
    NavigationMenuComponent,
    BreadcrumbComponent,
    StatusTagComponent
  ]
})
export class SharedComponentsModule { }